<template>
  <vs-popup
    :active.sync="popupActive"
    title="Verify identity"
    class="verify-otp-popup"
  >
    <p class="mb-4 text-sm">
      This action requires verification. Enter the 6-digit code from your Google Authenticator app.
    </p>
    <vs-input
      v-model="otpCode"
      label-placeholder="Authentication code"
      placeholder="000000"
      class="w-full"
      maxlength="6"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      @input="onOtpInput"
      @keyup.enter="submitOtp"
    />
    <div class="flex flex-wrap justify-between mt-4 mb-3">
      <vs-button type="border" @click="cancel">Cancel</vs-button>
      <vs-button
        :disabled="otpCode.length !== 6 || verifying"
        @click="submitOtp"
      >
        <vs-progress v-if="verifying" indeterminate size="small" color="primary"></vs-progress>
        <span v-else>Verify</span>
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import axios from '@/axios.js'

export default {
  name: 'VerifyOtpForAction',
  props: {
    userInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      popupActive: false,
      otpCode: '',
      verifying: false,
      pendingCallback: null,
    }
  },
  computed: {
    effectiveUserInfo() {
      if (this.userInfo && this.userInfo.uid) {
        return this.userInfo
      }
      try {
        const fromStore = this.$store.state.AppActiveUser
        if (fromStore && fromStore.uid) return fromStore
      } catch (e) {}
      try {
        const fromStorage = JSON.parse(localStorage.getItem('userInfo'))
        if (fromStorage && fromStorage.uid) return fromStorage
      } catch (e) {}
      return null
    },
    googleAuthEnabled() {
      const ui = this.effectiveUserInfo
      return ui && ui.google_auth === true
    },
  },
  methods: {
    onOtpInput() {
      this.otpCode = String(this.otpCode || '').replace(/\D/g, '').slice(0, 6)
    },
    cancel() {
      this.popupActive = false
      this.otpCode = ''
      this.pendingCallback = null
    },
    submitOtp() {
      if (this.otpCode.length !== 6 || this.verifying) return
      const self = this
      const uid = this.effectiveUserInfo.uid
      self.verifying = true
      axios
        .post('/clients/verify-totp', {
          uid,
          code: self.otpCode,
          platform: 'Web',
        })
        .then(function (response) {
          self.verifying = false
          if (response.data && response.data.error) {
            self.$vs.notify({
              title: 'Verification failed',
              text: response.data.error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            })
            return
          }
          self.popupActive = false
          self.otpCode = ''
          const cb = self.pendingCallback
          self.pendingCallback = null
          if (typeof cb === 'function') cb()
        })
        .catch(function (err) {
          self.verifying = false
          const msg =
            (err.response && err.response.data && err.response.data.error) ||
            err.message ||
            'Verification failed.'
          self.$vs.notify({
            title: 'Verification failed',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    /**
     * Run a privileged action. If Google Auth is enabled for the user,
     * shows OTP modal and runs the callback after successful verification.
     * Otherwise runs the callback immediately.
     * @param {Function} callback - Function to run (after OTP verify if 2FA enabled)
     */
    runIfVerified(callback) {
      if (typeof callback !== 'function') return
      if (!this.googleAuthEnabled) {
        callback()
        return
      }
      this.pendingCallback = callback
      this.otpCode = ''
      this.popupActive = true
    },
  },
}
</script>
